import { Trans } from '@lingui/react/macro'
import { BrandIcon } from '@jotta/ui/BrandIcon'
import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'
import styles from './NoSharedPhotos.module.scss'

import Debug from 'debug'
import SvgAlbumWithPhotos from '@jotta/ui/SvgAlbumWithPhotos'
const debug = Debug('jotta:NoSharedPhotos')
export const NoSharedPhotos = observer<PropsWithChildren<{}>>(
  function NoSharedPhotos({ children }) {
    return (
      <div className={styles.container}>
        <BrandIcon icon={SvgAlbumWithPhotos} className={styles.defaultSvg} />
        <h2 className={styles.title}>
          <Trans>You haven't shared anything yet!</Trans>
        </h2>
      </div>
    )
  },
)
